<template>
    <section>
        <div class="">
          <img class="" src="../assets/img/sukimatch/ask.png" alt="">
          
        </div>
    </section>
</template>

<script>
export default {
}
</script>

<style>

img {
    width: 100%;
    height: 100%;
}
</style>